import {Card} from 'platform/components';
import {Box} from 'platform/foundation';
import {match} from 'ts-pattern';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {
  catchUnhandledDataGridActions,
  DmsDataGrid,
  openActivityChangeLog,
  Section,
} from '@dms/shared';

import {useRequiredParams} from 'shared/web';

import {ActionCallback, QueryFilterObject} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['commandId'] as const;

export function ActionLog() {
  const {id} = useRequiredParams();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {record: id}]),
    [id]
  );

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = (data) => {
    const {actionKey, getColumnData} = data;
    const commandId = getColumnData('commandId')?.value;

    match(actionKey)
      .with('detail', () => {
        if (commandId && typeof commandId === 'string') {
          openActivityChangeLog({
            resourceId: EntityResourceIds.workshopInterest,
            commandId,
            recordId: id,
          });
        }
      })
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <Section>
      <Card title={i18n.t('general.labels.activityLogs')}>
        <Box>
          <DmsDataGrid
            actionCallback={actionCallback}
            predefinedColumns={PREDEFINED_COLUMNS}
            gridCode="workshop-interest-audit-log"
            autoHeight
            queryModifier={queryModifier}
            data-testid="workshop-interest-activity-logs-datagrid"
          />
        </Box>
      </Card>
    </Section>
  );
}
